import { DbListBase } from "./db-list-base";
import { ICollectionReference } from '../database-cast/IDatabase';
import { MethodCoverWhell } from '../../../core/_shared/models/method-task';
import { DbMethodCoverWhell } from './DbMethodCoverWhell';
export class DbMethodCoverWhells extends DbListBase<MethodCoverWhell> {
  getCoverWhell(id: string) {
    return new DbMethodCoverWhell(id, this._collection);
  }
  constructor(collection: ICollectionReference) {
    super(collection);
  }
}
